/* ============================================================
   LUMIE — Theme JavaScript
   Vanilla JS, no external dependencies
   ============================================================ */

'use strict';

/* ─── Sticky Header ─────────────────────────────────────── */
(function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
  document.body.prepend(sentinel);

  const obs = new IntersectionObserver(([entry]) => {
    header.classList.toggle('is-scrolled', !entry.isIntersecting);
  });
  obs.observe(sentinel);
})();

/* ─── Mobile Menu ────────────────────────────────────────── */
(function initMobileMenu() {
  const menuBtn  = document.getElementById('mobile-menu-btn');
  const closeBtn = document.getElementById('mobile-menu-close');
  const nav      = document.getElementById('mobile-nav');
  if (!menuBtn || !nav) return;

  const open  = () => { nav.classList.add('is-open');  document.body.style.overflow = 'hidden'; menuBtn.setAttribute('aria-expanded', 'true'); };
  const close = () => { nav.classList.remove('is-open'); document.body.style.overflow = ''; menuBtn.setAttribute('aria-expanded', 'false'); };

  menuBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);

  nav.addEventListener('click', (e) => { if (e.target === nav) close(); });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* ─── Search Overlay ─────────────────────────────────────── */
(function initSearch() {
  const searchBtns    = document.querySelectorAll('[data-search-open]');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose   = document.getElementById('search-close');
  const searchInput   = document.getElementById('search-input');
  if (!searchOverlay) return;

  const open  = () => { searchOverlay.classList.add('is-open');  searchInput?.focus(); document.body.style.overflow = 'hidden'; };
  const close = () => { searchOverlay.classList.remove('is-open'); document.body.style.overflow = ''; };

  searchBtns.forEach(btn => btn.addEventListener('click', open));
  if (searchClose) searchClose.addEventListener('click', close);
  searchOverlay.addEventListener('click', (e) => { if (e.target === searchOverlay) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* ─── Cart Drawer ────────────────────────────────────────── */
window.LumieCart = (function() {
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const count   = document.querySelectorAll('.cart-count');

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateCount(cart.item_count);
      renderItems(cart);
    } catch (e) { /* fail silently */ }
  }

  function updateCount(n) {
    count.forEach(el => {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
  }

  function renderItems(cart) {
    const itemsEl   = document.getElementById('cart-items');
    const emptyEl   = document.getElementById('cart-empty');
    const subtotalEl = document.getElementById('cart-subtotal');
    const footerEl  = document.querySelector('.cart-drawer__footer');

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl?.removeAttribute('hidden');
      if (footerEl) footerEl.hidden = true;
      return;
    }

    emptyEl?.setAttribute('hidden', '');
    if (footerEl) footerEl.hidden = false;

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__img" src="${item.image}" alt="${item.product_title}" width="80" height="80" loading="lazy">
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="qty-selector">
            <button class="qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Diminuer">−</button>
            <input class="qty-input" type="text" value="${item.quantity}" readonly aria-label="Quantité">
            <button class="qty-btn" data-action="increase" data-key="${item.key}" aria-label="Augmenter">+</button>
          </div>
        </div>
        <div>
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <button class="cart-item__remove" data-key="${item.key}" aria-label="Supprimer ${item.product_title}">Retirer</button>
        </div>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key    = btn.dataset.key;
        const action = btn.dataset.action;
        const item   = cart.items.find(i => i.key === key);
        if (!item) return;
        const qty = action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        await updateItem(key, qty);
      });
    });

    itemsEl.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => updateItem(btn.dataset.key, 0));
    });
  }

  async function updateItem(key, quantity) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      updateCount(cart.item_count);
      renderItems(cart);
    } catch (e) { /* fail silently */ }
  }

  async function addItem(variantId, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity, properties })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      open();
      return res.json();
    } catch (e) {
      showToast('Erreur lors de l\'ajout au panier');
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-CA', { style: 'currency', currency: window.Shopify?.currency?.active || 'CAD' });
  }

  // Init listeners
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', open));
    overlay?.addEventListener('click', close);
    document.getElementById('cart-close')?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    refreshCart();
  });

  return { open, close, addItem, refreshCart };
})();

/* ─── Add to Cart Forms ──────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      if (!btn) return;

      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      btn.disabled = true;
      const original = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span>';

      await window.LumieCart.addItem(variantId);

      btn.disabled = false;
      btn.innerHTML = original;
    });
  });

  // Quick add buttons on product cards
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      const orig = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span>';
      await window.LumieCart.addItem(variantId);
      btn.disabled = false;
      btn.innerHTML = orig;
    });
  });
});

/* ─── Testimonials Carousel ──────────────────────────────── */
(function initCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev  = carousel.querySelector('[data-carousel-prev]');
    const next  = carousel.querySelector('[data-carousel-next]');
    const dots  = carousel.querySelectorAll('[data-carousel-dot]');
    if (!track) return;

    const cardWidth = () => track.querySelector('[data-carousel-item]')?.offsetWidth + 24 || 300;

    const scrollTo = (index) => {
      track.scrollTo({ left: cardWidth() * index, behavior: 'smooth' });
    };

    const getActive = () => Math.round(track.scrollLeft / cardWidth());

    const updateDots = () => {
      const active = getActive();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };

    prev?.addEventListener('click', () => scrollTo(Math.max(0, getActive() - 1)));
    next?.addEventListener('click', () => {
      const items = track.querySelectorAll('[data-carousel-item]').length;
      scrollTo(Math.min(items - 1, getActive() + 1));
    });
    dots.forEach((dot, i) => dot.addEventListener('click', () => scrollTo(i)));
    track.addEventListener('scroll', updateDots, { passive: true });
  });
})();

/* ─── Announcement Bar Close ─────────────────────────────── */
(function initAnnouncementBar() {
  const closeBtn = document.getElementById('announcement-close');
  const bar      = document.getElementById('announcement-bar');
  if (!closeBtn || !bar) return;

  closeBtn.addEventListener('click', () => {
    bar.classList.add('is-hidden');
    sessionStorage.setItem('lumie-announcement-hidden', '1');
  });

  if (sessionStorage.getItem('lumie-announcement-hidden') === '1') {
    bar.classList.add('is-hidden');
  }
})();

/* ─── Toast Notification ─────────────────────────────────── */
function showToast(message, duration = 3000) {
  let toast = document.getElementById('lumie-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'lumie-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  setTimeout(() => toast.classList.remove('is-visible'), duration);
}

/* ─── Variant Selector (Product Page) ───────────────────── */
(function initVariantSelector() {
  document.querySelectorAll('[data-variant-form]').forEach(form => {
    const selects = form.querySelectorAll('[data-option-select]');
    const priceEl = form.querySelector('[data-price]');
    const comparePriceEl = form.querySelector('[data-compare-price]');
    const addBtn  = form.querySelector('[data-add-to-cart]');
    const variants = JSON.parse(form.dataset.variants || '[]');

    // Construit une URL d'image redimensionnée (plus légère à charger)
    function sizedSrc(src) {
      if (!src) return src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
    }

    // Précharge toutes les images de variantes pour un changement instantané
    variants.forEach(v => {
      if (v.featured_image && v.featured_image.src) {
        const img = new Image();
        img.src = sizedSrc(v.featured_image.src);
      }
    });

    function findVariant() {
      const selected = Array.from(selects).map(s => s.value);
      return variants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    function update() {
      const variant = findVariant();
      if (!variant) return;

      form.querySelector('[name="id"]').value = variant.id;

      // Change l'image principale selon l'image de la variante (déjà préchargée)
      if (variant.featured_image && variant.featured_image.src) {
        const mainImg = document.getElementById('product-main-img');
        if (mainImg) {
          mainImg.srcset = '';
          mainImg.src = sizedSrc(variant.featured_image.src);
        }
      }

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;
      } else if (comparePriceEl) {
        comparePriceEl.hidden = true;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.dataset.addText || 'Ajouter au panier'
          : addBtn.dataset.soldText || 'Épuisé';
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-CA', { style: 'currency', currency: window.Shopify?.currency?.active || 'CAD' });
    }

    selects.forEach(s => s.addEventListener('change', update));
    update();
  });
})();

/* ─── Quantity Selector (Product Page) ──────────────────── */
(function initQtySelectors() {
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const input = sel.querySelector('.qty-input');
    if (!input || input.readOnly) return; // cart drawer handles its own

    sel.querySelector('[data-action="decrease"]')?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    sel.querySelector('[data-action="increase"]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });
})();
